import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// Load Microsoft Clarity only in production
if (environment.production) {
  (function (c: Record<string, unknown>, l: Document, a: string, r: string, i: string) {
    const w = c as { [key: string]: unknown };
    w[a] = w[a] || function () { ((w[a] as { q?: unknown[] }).q = (w[a] as { q?: unknown[] }).q || []).push(arguments); };
    const t = l.createElement(r) as HTMLScriptElement;
    t.async = true;
    t.src = "https://www.clarity.ms/tag/" + i;
    const y = l.getElementsByTagName(r)[0];
    y?.parentNode?.insertBefore(t, y);
  })(window as unknown as Record<string, unknown>, document, "clarity", "script", "pm1vhn6iuf");
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch(err => console.error(err));
